/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { get, isEmpty } from "lodash";
// page
import UserContract from "./UserContract";
import AdminContract from "./AdminContract";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import PencilIcon from "../../assets/images/icon/pencil-icon.svg";
import Icon from "../../components/Icon";
import { contractRequest } from "../../utils/contract";
import { permissionCheck } from "../../utils/permission";

const ElectronicContract = () => {
  const history = useHistory();
  const {
    user,
    employee,
    permissions,
  } = useSelector(
    (store) => ({
      user: store.Profile.user,
      employee: store.Profile.employee,
      permissions: store.Profile.permissions,
    }),
    shallowEqual
  );
  const [activeTab, setActiveTab] = useState('all-user-contract');
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'CONTRACT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "CONTRACT")
      }
    }
  }, [permissions])

  const _setActiveTab = (value) => {
    history.push(`/electronic/labor?tab=${value}`);
  };

  const adminTabList = [
    { label: "전자계약 조회 및 요청", action: _setActiveTab, value: 'all-user-contract' },
    ...user && user.companyType === user.type ? [{ label: `${get(employee, "name")}님의 전자계약`, action: _setActiveTab, value: 'my-contract' }] : [],
  ];

  const tabList = [
    { label: `${get(employee, "name")}님의 전자계약`, action: _setActiveTab, value: 'my-contract' },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || (targetPermission && targetPermission.level === 9 ? adminTabList[0].value : tabList[0].value));
  }, [history.location, targetPermission]);

  // useEffect(() => {
  //   const query = queryString.parse(history.location.search);
  //   if (query && query.id) {

  //   }
  // }, [history.location])

  const headerButtons = [
    {
      label: <>새 전자계약서 <Icon src={PencilIcon} /></>,
      action: () => {
        contractRequest(null)
      },
    },
  ];
  return (
    !isEmpty(targetPermission) && (
      <div className="print-out">
        <PageHeader title={"전자계약"} activeTab={activeTab} tabList={targetPermission.level === 9 ? adminTabList : tabList}
          buttons={targetPermission.level === 9 ? headerButtons : []}
        />
        {activeTab === 'all-user-contract' && <AdminContract />}
        {activeTab === 'my-contract' && <UserContract user={employee} />}
      </div>
    )
  );
};

export default ElectronicContract;
